import ForgotPasswordModifyPage from "src/Pages/Auth/ForgotPasswordModifyPage";
import ForgotPasswordVerifyPage from "src/Pages/Auth/ForgotPasswordVerifyPage";
import LoginPage from "src/Pages/Auth/LoginPage";
import RegisterPage from "src/Pages/Auth/RegisterPage";
import RegisterPagePassword from "src/Pages/Auth/RegisterPagePassword";
import RegisterPageToken from "src/Pages/Auth/RegisterPageToken";
import CheckoutPage from "src/Pages/Checkout/CheckoutPage";
import MultiCheckoutPage from "src/Pages/Checkout/MultiCheckoutPage";
import PreCheckoutPage from "src/Pages/Checkout/PreCheckoutPage";
import FormPublicPage from "src/Pages/Forms/FormPublicPage";
import FormsPublicPage from "src/Pages/Forms/FormsPublicPage";

export const generalRoutes = [
  { path: `${process.env.PUBLIC_URL}/auth/sign-in`, Component: <LoginPage /> },
  { path: `${process.env.PUBLIC_URL}/auth/sign-in/forgot`, Component: <ForgotPasswordVerifyPage /> },
  { path: `${process.env.PUBLIC_URL}/auth/sign-in/forgot/modify`, Component: <ForgotPasswordModifyPage /> },
  { path: `${process.env.PUBLIC_URL}/auth/sign-up`, Component: <RegisterPage /> },
  { path: `${process.env.PUBLIC_URL}/auth/sign-up/token`, Component: <RegisterPageToken /> },
  { path: `${process.env.PUBLIC_URL}/auth/sign-up/password`, Component: <RegisterPagePassword /> },
  { path: `${process.env.PUBLIC_URL}/checkout/pre`, Component: <PreCheckoutPage /> },
  { path: `${process.env.PUBLIC_URL}/checkout/multi`, Component: <MultiCheckoutPage /> },
  { path: `${process.env.PUBLIC_URL}/checkout/:seller?`, Component: <CheckoutPage /> },
  { path: `${process.env.PUBLIC_URL}/crm/home`, Component: <FormsPublicPage /> },
  { path: `${process.env.PUBLIC_URL}/form/:slug`, Component: <FormPublicPage /> },
];
